import React, { Suspense, useState } from 'react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom';

import { LoadingScreen } from '~components/atoms';
import { WithStationOfflineEffect } from '~components/molecules';
import {
  BadStatusStationPage,
  ErrorPage,
  HomePage,
  RentalPage,
  SuccessPage,
  WelcomeBackPage,
} from '~components/pages';
import { MainLayout } from '~components/templates';
import {
  BAD_STATION_STATUS_PAGE_PATH,
  HOMEPAGE_PATH,
  RENTAL_PAGE_PATH,
  SUCCESS_PAGE_PATH,
  WELCOME_BACK_PAGE_PATH,
} from '~configs';
import { AppBannerSettingProvider, LanguageProvider } from '~providers';
import { featureFlagsService } from '~services';

// createBrowserRouter starts the `/` loader as soon as it is called, so the
// router is created on the first render, once TenantProvider knows the tenant.
const createRouter = () =>
  createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route
          path={HOMEPAGE_PATH}
          loader={async () => {
            try {
              // Fetch flags from service rental
              await featureFlagsService.handleFetchFeatureFlags();
            } catch (err) {
              // eslint-disable-next-line no-console
              console.error('Failed to load resources with reason:', err);
            }

            // loader requires a return
            return null;
          }}
          element={
            // Suspense is used to wait for i18n initialization
            <Suspense fallback={<LoadingScreen />}>
              <LanguageProvider>
                <AppBannerSettingProvider>
                  <MainLayout />
                </AppBannerSettingProvider>
              </LanguageProvider>
            </Suspense>
          }
        >
          <Route index element={<HomePage />} />
          <Route path={RENTAL_PAGE_PATH} element={<RentalPage />} />
          <Route path={SUCCESS_PAGE_PATH} element={<SuccessPage />} />
          <Route
            path={WELCOME_BACK_PAGE_PATH}
            element={
              <WithStationOfflineEffect>
                <WelcomeBackPage />
              </WithStationOfflineEffect>
            }
          />
          <Route path={BAD_STATION_STATUS_PAGE_PATH}>
            <Route path={`:status`} element={<BadStatusStationPage />} />
          </Route>
        </Route>
        {/* OTHER ROUTE */}
        <Route path="*" element={<ErrorPage />} />
      </>,
    ),
  );

export const AppRouter = () => {
  const [router] = useState(createRouter);

  return <RouterProvider router={router} />;
};
